define('modules/signup/index',['require','exports','module','./resetpassword/model','./forget/view','./resetpassword/view'],function(require, exports, module) {
    "use strict";

    module.exports = {        
        Models: {
            ResetPassword: require("./resetpassword/model")
        },
        Views: {              
              Forget: require("./forget/view"),
              ResetPassword: require("./resetpassword/view")
        }
    };
});

